/**
 * Notices the invoice API attaches to a document it accepted.
 *
 * A warning is not a refusal: the invoice was created, the XML was generated
 * and it is on its way to the Sistema di Interscambio. It is something the
 * operator has to be told anyway — today, that the total does not match the
 * sum of the lines, which is expected while marca da bollo, ritenuta d'acconto
 * and cassa previdenziale cannot yet be written onto the document.
 *
 * The backend sends `{ code, params, message }`. `message` is already Italian,
 * but it is written for whoever calls the API; the catalog entry keyed on the
 * same code is written for whoever is looking at the screen, and wins when it
 * exists. Kept free of Svelte imports so it can be unit-tested directly.
 */

import { tImmediate } from '../i18n/index.js';

/** The catalog namespace holding the on-screen wording of every warning. */
const NAMESPACE = 'invoiceWarnings';

/**
 * @param {Array<{code?: string, params?: object, message?: string}>} warnings
 * @returns {Array<{code: string|null, text: string, detail: string}>}
 *   `text` states what was found, `detail` explains what to do about it
 *   (empty when the warning needs no explanation).
 */
export function invoiceWarningNotices(warnings) {
  return (warnings || [])
    .map((warning) => {
      // The backend namespaces its codes ('errors.fatturapa.totaleNonQuadra');
      // the last segment is the name both catalogs agree on.
      const name = String(warning?.code || '').split('.').pop();
      const message = warning?.message || '';
      return {
        code: warning?.code || null,
        text: name ? tImmediate(`${NAMESPACE}.${name}`, warning?.params, message) : message,
        detail: name ? tImmediate(`${NAMESPACE}.${name}Detail`, undefined, '') : '',
      };
    })
    .filter((notice) => notice.text);
}
